import React from 'react';

/**
 * Fixed brand-color vignette overlay (purple / cyan) across the whole site.
 */
const SiteAmbientGlow: React.FC = () => (
  <div className="site-ambient-glow" aria-hidden="true" />
);

export default SiteAmbientGlow;
